var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payroll_Concept",
    "data-name": "Payroll Concept"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.23,12.55,16.51,4.83a.87.87,0,0,0-.64-.27,1,1,0,0,0-.7.27,1,1,0,0,0-.33.64V9.06H8.42a1,1,0,0,0-1,1v6.26a1,1,0,0,0,1,1h6.42v3.59a1,1,0,0,0,1,.91.91.91,0,0,0,.66-.27l7.72-7.72a.87.87,0,0,0,.27-.64A.86.86,0,0,0,24.23,12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,22.56H5.51a4,4,0,0,1-4-4V7.44a4,4,0,0,1,4-4H10.7a1,1,0,0,1,0,2H5.51a2,2,0,0,0-2,2V18.56a2,2,0,0,0,2,2H10.7a1,1,0,0,1,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.93f0869fd13994a0a89f5b1238a91273.svg";
export { ForwardRef as ReactComponent };